import { FunctionsHttpError } from '@supabase/supabase-js'

export async function readFunctionError(error: unknown): Promise<string> {
  if (error instanceof FunctionsHttpError) {
    try {
      const payload = (await error.context.json()) as { error?: string; message?: string }
      if (payload?.error) return payload.error
      if (payload?.message) return payload.message
    } catch {
      /* ignore */
    }
  }
  if (error instanceof Error && error.message) return error.message
  return 'Request failed'
}
